import React from 'react';
// import { TTLogo } from '~routes/login-page/svgs';
import { connect } from 'react-redux';
import { logUser, logIn } from '~redux_related/user/actionCreators';
import LoginForm from './login-form';
import ResetForm from './reset-password-form';
import NewPasswordForm from './new-password-form';
import '~routes/login-page/style.scss';

function Login({ isMobile, isFetching, redirectPath, logUser, logIn }) {
    const [state, switchForms] = React.useState(false);
    const passwordRecovery = React.useMemo(() => {
        const pageParams = new URLSearchParams(document.location.search.substring(1));
        if (pageParams instanceof Object) {
            return pageParams.get('password_recovery') || '';
        }
        return '';
    }, []);

    return (
        <div className="login-page__form">
            <div className="login-page__inner-container">
                <div className="login-page__inner-wrap">
                    {state && !passwordRecovery && (
                        <ResetForm isMobile={isMobile} backCallback={() => switchForms(false)} />
                    )}
                    {!state && !passwordRecovery && (
                        <LoginForm
                            isMobile={isMobile}
                            switchForms={switchForms}
                            isFetching={isFetching}
                            logUser={logUser}
                            redirectPath={redirectPath}
                        />
                    )}
                    {passwordRecovery && (
                        <NewPasswordForm
                            isMobile={isMobile}
                            isFetching={isFetching}
                            logIn={logIn}
                            redirectPath={redirectPath}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
    isFetching: state.user.isUserFetching,
    redirectPath: state.ui.redirectPath,
});

const mapDispatchToProps = (dispatch) => ({
    logUser: ({ username, password }) => dispatch(logUser({ username: username, password: password })),
    logIn: (user) => dispatch(logIn(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/routes/login-page/login/index.js